import React, { useState } from 'react'
import PropTypes from 'prop-types'
import {
  TableRow,
  TableCell,
  IconButton,
  Typography,
  Tooltip,
  Collapse,
  Grid,
  useTheme,
  useMediaQuery,
} from '@material-ui/core'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight'
import EditIcon from '@material-ui/icons/Edit'
import { DetailPanel } from 'components/DescricoesVestigiosExame/DescricoesTecnicasVestigio/DetailPanel'
import { getLabelTipoVestigioEspecifico, getTipoVestigioLabel } from 'helpers/labels'
import { useStyles } from '../ExameEficienciaBalistica.styles'

export const LinhaTabelaColetaPadrao = (props) => {
  const {
    descricaoTecnica,
    handleClickOpenFormularioExtracaoPadrao,
  } = props

  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const [openDetail, setOpenDetail] = useState(false)

  if (isMobile) {
    return (
      <div className={classes.cardMobile}>
        <div className={classes.cabecalhoCard}>
          <Typography style={{ fontSize: '13px', fontWeight: 'bold' }}>
            #{descricaoTecnica.id} -{' '}
            {getTipoVestigioLabel(descricaoTecnica.tipoVestigioGenerico)?.toUpperCase()}
          </Typography>
          <div className={classes.acoesCard}>
            <Tooltip title="Realizar extração de padrão">
              <IconButton
                size="small"
                disabled={!!descricaoTecnica.descVestBal?.vestExtraido}
                onClick={() => handleClickOpenFormularioExtracaoPadrao(descricaoTecnica)}
              >
                <EditIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <IconButton size="small" onClick={() => setOpenDetail(!openDetail)}>
              {openDetail ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
            </IconButton>
          </div>
        </div>
        <div className={classes.conteudoCard}>
          <span className={classes.labelCard}>Especificação: </span>
          {getLabelTipoVestigioEspecifico(descricaoTecnica.tipoVestigioEspecifico)?.toUpperCase()}
        </div>
        <div className={classes.conteudoCard}>
          <span className={classes.labelCard}>Extração: </span>
          {descricaoTecnica.descVestBal?.vestExtraido ? 'REALIZADA' : 'NÃO REALIZADA'}
        </div>

        {openDetail && (
          <Collapse in={openDetail} timeout="auto" unmountOnExit>
            <div style={{ marginTop: theme.spacing(1) }}>
              <DetailPanel
                idDescricaoTecnica={descricaoTecnica.id}
                tipoVestigio={descricaoTecnica.tipoVestigioGenerico}
              >
                <Grid item className={classes.divTitulo} sm={12} xs={12} md={12}>
                  <Typography variant="subtitle2">
                    <b>COLETA DE PADRÃO</b>
                  </Typography>
                </Grid>
                {descricaoTecnica.descVestBal?.vestExtraido ? (
                  <Grid item container md={12} sm={12} xs={12} spacing={1} className={classes.grupoEspelho}>
                    <Grid item md={12} sm={12} xs={12}>
                      <Typography className={classes.dadoEspelho}>
                        <b>VESTÍGIO EXTRAÍDO</b>
                      </Typography>
                      <Typography variant="body2">
                        {descricaoTecnica.descVestBal.vestExtraido?.identificador || 'NÃO REALIZADO'}
                      </Typography>
                    </Grid>
                  </Grid>
                ) : (
                  <Grid item container md={12} sm={12} xs={12} className={classes.grupoEspelho}>
                    <Grid item md={12} sm={12} xs={12}>
                      <Typography variant="body2" className={classes.dadoEspelho}>
                        Não foi realizada extração de padrão neste item
                      </Typography>
                    </Grid>
                  </Grid>
                )}
              </DetailPanel>
            </div>
          </Collapse>
        )}
      </div>
    )
  }

  // Desktop Table Row
  return (
    <>
      <TableRow className={classes.tableRow} onClick={() => setOpenDetail(!openDetail)}>
        <TableCell style={{ width: '5%' }}>
          <IconButton aria-label="expand row" size="small">
            {openDetail ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
          </IconButton>
        </TableCell>
        <TableCell style={{ width: '30%' }}>
          <Typography style={{ fontSize: '13px' }}>
            #{descricaoTecnica.id} -{' '}
            {getTipoVestigioLabel(descricaoTecnica.tipoVestigioGenerico)?.toUpperCase()} -{' '}
            {getLabelTipoVestigioEspecifico(descricaoTecnica.tipoVestigioEspecifico)?.toUpperCase()}
          </Typography>
        </TableCell>

        <TableCell style={{ width: '45%' }}>
          {descricaoTecnica.descVestBal?.vestExtraido ? (
            <Typography>REALIZADA</Typography>
          ) : (
            <Typography>NÃO REALIZADA</Typography>
          )}
        </TableCell>
        <TableCell style={{ width: '20%' }} onClick={(e) => e.stopPropagation()}>
          <Tooltip title="Realizar extração de padrão">
            <IconButton
              size="small"
              disabled={!!descricaoTecnica.descVestBal?.vestExtraido}
              onClick={() => handleClickOpenFormularioExtracaoPadrao(descricaoTecnica)}
            >
              <EditIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </TableCell>
      </TableRow>

      {openDetail && (
        <TableRow>
          <TableCell colSpan={6} style={{ paddingBottom: 0, paddingTop: 0 }}>
            <Collapse in={openDetail} timeout="auto" unmountOnExit>
              <DetailPanel
                idDescricaoTecnica={descricaoTecnica.id}
                tipoVestigio={descricaoTecnica.tipoVestigioGenerico}
              >
                <Grid item className={classes.divTitulo} sm={12} xs={12} md={12}>
                  <Typography variant="subtitle2">
                    <b>COLETA DE PADRÃO</b>
                  </Typography>
                </Grid>
                {descricaoTecnica.descVestBal?.vestExtraido ? (
                  <Grid item container md={12} sm={12} xs={12} spacing={1} className={classes.grupoEspelho}>
                    <Grid item md={6} sm={6} xs={12}>
                      <Typography className={classes.dadoEspelho}>
                        <b>VESTÍGIO EXTRAÍDO</b>
                      </Typography>
                      <Typography variant="body2">
                        {descricaoTecnica.descVestBal.vestExtraido?.identificador || 'NÃO REALIZADO'}
                      </Typography>
                    </Grid>
                  </Grid>
                ) : (
                  <Grid item container md={12} sm={12} xs={12} className={classes.grupoEspelho}>
                    <Grid item md={6} sm={6} xs={12}>
                      <Typography variant="body2" className={classes.dadoEspelho}>
                        Não foi realizada extração de padrão neste item
                      </Typography>
                    </Grid>
                  </Grid>
                )}
              </DetailPanel>
            </Collapse>
          </TableCell>
        </TableRow>
      )}
    </>
  )
}

LinhaTabelaColetaPadrao.propTypes = {
  descricaoTecnica: PropTypes.object.isRequired,
  handleClickOpenFormularioExtracaoPadrao: PropTypes.func.isRequired,
  idExameRealizado: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
}
